import React,{ useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {Button,Card,Form,Container,Row,Col} 
from "react-bootstrap";
import { confirmAlert } from 'react-confirm-alert'; 
import 'react-confirm-alert/src/react-confirm-alert.css'; 
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import DataTable from "react-data-table-component";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faEdit,faDeleteLeft} from "@fortawesome/free-solid-svg-icons";
import "assets/css/grid.css";
import {MensajeAlerta} from '../components/Messages/MensajeAlerta';
import "react-datetime/css/react-datetime.css";
import 'moment/locale/es';
import { useActividades } from 'hooks/useActividades';

const paginacionOpciones={
    rowsPerPageText:'Número elementos',
    rangeSeparatorText:'de',
    selectAllRowsItemsText:'Todos'
}
function ListadoActividadesAsistencia(){
   
    const { actividades,getActividades,insertActividad,updateRespuestaIngresarActividad,respuestaIngresarActividad,disabledActividad} = useActividades();
    const [isChangedElements,setChange]=useState(false);
    const [actividadPorIngresar, setActividadPorIngresar] = useState({});
    const [disable, setDisable] = useState(false);

    const columnas=[
    {
        name:'Valor',
        selector: row => row.Valor,
        sorteable:true,
        omit:true
    },
    {
        name:'Nombre',
        selector: row => row.Nombre,
        sorteable:true
               
    },
    {
      name:'Sigla',
      selector: row => row.Sigla,
      sorteable:true
             
  },
    {
      name:'Descripción',
      selector: row => row.Descripcion,
      sorteable:true
             
  },
    ,
    {
       
		cell: row => (
            <>
            <a href={'EditarActividad/'+row.Valor} rel="noopener noreferrer">
            	<FontAwesomeIcon icon={faEdit} />
            </a>
            &nbsp;&nbsp;&nbsp;
            <a href="#" onClick={event=>onDisabled(row.Valor)} rel="noopener noreferrer" title='Eliminar'>
            	<FontAwesomeIcon icon={faDeleteLeft} />
            </a>
            </>       
        ),
    }];
    const crearActividad = async() => {
      setChange(false);
      const resp=await insertActividad(actividadPorIngresar);
      if(resp?.success)
      {
        setActividadPorIngresar({'Nombre':'','Descripcion':''});             
      }
      setChange(true);
    };
    const onDisabled=async n=>{
    
      confirmAlert({
          title: '',
          message: '¿Seguro desea eliminar actividad?',
          buttons: [
            {
              label: 'Si',
              onClick: async() => {
                await disabledActividad(n);
                
                setDisable(true)}
            },
            {
              label: 'No'
              
            }
          ]
        });
  
  }

    useEffect( () => {
      async function ActividadesFuncion(){
        await getActividades();
      }
      ActividadesFuncion();
    }, []);
  
    useEffect( () => {
      async function ActividadesFuncion(){
        await updateRespuestaIngresarActividad();  
        await getActividades();
      }
      ActividadesFuncion();
    }, [isChangedElements]);

    useEffect( () => {
      if(disable){
          
          async function ActividadesFuncion(){
              getActividades();
          }
          ActividadesFuncion();
          setDisable(false)

      }
      

      
  }, [disable]);
  
    return (
            <>
             <Container fluid>
              <Row>
                <Col xs="12">
                  <Card className="strpied-tabled-with-hover">
                    <Card.Header>
                        <Card.Title as="h4">Listado de actividades</Card.Title>
                        <p className="card-category">
                          En esta sección puede gestionar actividades</p>
                    </Card.Header>
                    <Card.Body className="table-full-width table-responsive px-0">
                    
                        <div className="button-container mr-auto ml-auto">
                        
                          <Tabs
                          defaultActiveKey="1"
                          id="uncontrolled-tab-example"
                          className="mb-3"
                          style={{marginLeft:0}}
                          >   
                            <Tab eventKey={1} title={'Listado Actividades'}>
                              <div className='table-responsive'>
                                <DataTable
                                columns={columnas}
                                data={actividades}
                                pagination
                                paginationComponentOptions={paginacionOpciones}
                                fixedHeader
                                fixedHeaderScrollHeight='600px'
                                noDataComponent="No hay elementos para mostrar"
                                striped={true}
                              />
                              </div>

                            </Tab>
                            <Tab eventKey={2} title={'Agregar Actividad'} style={{marginLeft:2,marginRight:2}}>
                                
                                <Row>
                                  <Col xs="6">
                                    <label>Nombre</label>
                                    <Form.Control
                                    value={actividadPorIngresar?.Nombre}
                                    placeholder=""
                                    type="text"
                                    onChange={(e,prop) => { 
                                      setActividadPorIngresar({...actividadPorIngresar,['Nombre']:e.target.value});
                                    }}
                                    rows={12}>
                                    </Form.Control>
                                  </Col>
                                  <Col xs="6">
                                    <label>Sigla</label>
                                    <Form.Control
                                    value={actividadPorIngresar?.Sigla}
                                    placeholder=""
                                    type="text"
                                    onChange={(e,prop) => { 
                                      setActividadPorIngresar({...actividadPorIngresar,['Sigla']:e.target.value});
                                    }}
                                    rows={12}>
                                    </Form.Control>
                                  </Col>
                                </Row>
                           
                            <Row>
                                <Col xs="12">
                            
                                <label>Descripción</label>
                                <Form.Control
                                    value={actividadPorIngresar?.Descripcion}
                                    placeholder=""
                                    type="textarea"
                                    as="textarea"
                                    onChange={(e,prop) => { 
                                      setActividadPorIngresar({...actividadPorIngresar,['Descripcion']:e.target.value});
                                    }}
                                    rows={12}>
                                </Form.Control>
                              
                                </Col>
                              
                            </Row>
                            <MensajeAlerta mensajeTexto={respuestaIngresarActividad.mensajeTexto} estado={respuestaIngresarActividad.estado} />
                            <Row>
                                <Col xs="6">
                                </Col>
                                <Col xs="6">
                              <br></br>
                                <Button
                                    className="btn-fill pull-right"
                                    type="submit"
                                    variant="info"
                                    onClick={(e)=>{
                                        e.preventDefault();
                                        crearActividad();
                                    }}
                                  >
                                Ingresar Actividad
                              </Button>
                              <br></br>
                                </Col>
                            </Row>
                            </Tab>
                          </Tabs>
                        
                        </div>
                      </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Container>
            </>
        )
}
export default ListadoActividadesAsistencia;